/*=========================================================================================
  File Name: moduleCustomerState.js
  Description: Customer Module State
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default { 
}